import React, { memo, useEffect, useRef, useState } from "react";
import { HighlightWithinTextarea } from 'react-highlight-within-textarea';
import { toNumber } from "@common/lib/toNumber";
import { Block, NumberTaxonomyEntry } from "../../types";
import { InputComponentProps } from "./common";
import { extractHumanReadableText } from "../../Document/InnodomContent/util";

interface NumberInputComponentProps extends InputComponentProps<NumberTaxonomyEntry, number> {
  block: Block;
}

const NumberInputComponent = ({
  active,
  id,
  onFocus,
  onUpdate,
  value,
  block
}: NumberInputComponentProps) => {
  const focusRef = useRef<HTMLInputElement>(null);
  const [highlights, setHighlights] = useState<Array>([]);

  useEffect(() => {
    if (block) {
      let textVal = extractHumanReadableText(block.element);

      if (textVal.indexOf("" + value.valueRaw) === -1) {
        setHighlights([0, value.valueRaw.length]);
      } else {
        setHighlights([]);
      }
    }

  }, [value.valueRaw]);

  useEffect(() => {
    if (!focusRef.current) {
      return;
    }
    if (active && focusRef.current.focus) {
      focusRef.current.focus();
    } else if (focusRef.current.blur) {
      focusRef.current.blur();
    }
  }, [active]);
  return (
    <>
      <HighlightWithinTextarea
        autoComplete="off"
        inputMode="decimal"
        id={id}
        ref={focusRef}
        onChange={e => {
          // For some reason it sometimes fires on change when getting/losing focus.
          // We don't want this to fire an event or it will cause the point to get selected
          // for no reason
          if (e !== value.valueRaw) {
            if (/^[\d\(\),\.-\s\+\$]*$/.test(e)) {
              onUpdate(id, toNumber(e), e);
            }
          }
        }}
        onFocus={() => {
          onFocus(id);
        }}
        value={value.valueRaw}
        highlight={highlights}
        placeholder=""
      />
    </>
    
  );
};
NumberInputComponent.displayName = "NumberInput";
export const NumberInput = memo(NumberInputComponent);
